import { JsonDatePipe } from "./../pipes/json-date.pipe";
import { Artikel } from "./../classes/artikel";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ArtikelService {
  constructor() {}

  public lieferdatumToDate(
    datum: string,
    hour: number = 0,
    minute: number = 0,
    second: number = 0,
    millsecond: number = 0
  ): Date {
    if (!datum) {
      const d: Date = new Date();
      d.setHours(hour, minute, second, millsecond);
      return d;
    } else {
      return new Date(
        Number.parseInt(datum.substr(6, 4), 10),
        Number.parseInt(datum.substr(3, 2), 10) - 1,
        Number.parseInt(datum.substr(0, 2), 10)
      );
    }
  }

  public nochNichtLieferbar(item: Artikel, lieferdatum: string): boolean {
    const ab: Date = new JsonDatePipe().transform(item.lieferbarAb);
    ab.setHours(0, 0, 0, 0);
    return ab > this.lieferdatumToDate(lieferdatum);
  }

  public nichtMehrLieferbar(item: Artikel, lieferdatum: string): boolean {
    const bis: Date = new JsonDatePipe().transform(item.lieferbarBis);
    bis.setHours(23, 59, 59, 999);
    return bis < this.lieferdatumToDate(lieferdatum);
  }

  public lieferbar(
    item: Artikel,
    lieferdatum: string,
    nochNichtLieferbareAnzeigen: boolean
  ): boolean {
    if (nochNichtLieferbareAnzeigen) {
      if (!item.lieferbarTermine) {
        const ab: Date = new JsonDatePipe().transform(item.lieferbarAb);
        ab.setHours(0, 0, 0, 0);
        const bis: Date = new JsonDatePipe().transform(item.lieferbarBis);
        bis.setHours(23, 59, 59, 999);
        return (
          ab <= this.lieferdatumToDate(lieferdatum) &&
          bis >= this.lieferdatumToDate(lieferdatum)
        );
      } else {
        const lfDatum: Date = this.lieferdatumToDate(lieferdatum);
        let found = false;
        item.lieferbarTermine.forEach((element) => {
          const d: Date = new JsonDatePipe().transform(element);
          d.setHours(0, 0, 0, 0);
          if (d.toISOString() === lfDatum.toISOString()) {
            found = true;
          }
        });
        return found;
      }
    } else {
      return item.verfuegbar;
    }
  }
}
